import { Link } from "gatsby";
import BlockContent from "../../block-content";
import { imageUrlFor } from "../../../lib/image-url";


const SocialPost = function ({post: socialPost, refreshLayout}) {
    const imageAsset = socialPost?.image?.asset;
    const imageId = imageAsset?._id;
    // TODO: We can create a placeholder image if you'd like instead of returning empty string
    const imageSrc = imageId
      ? imageUrlFor(imageId)
          .auto("format")
          .width(586)
          .quality(65)
          .url()
      : "";
    const imageSize = imageAsset?.metadata?.dimensions;
    const imageWidth = imageSize?.width;
    const imageHeight = imageSize?.height;
    const postType = socialPost?.socialPostType;
    const handleUrl = postType?.handleUrl || "";
    const tagUrl = postType?.tagUrl || "";

    return (
      <div
        key={socialPost._id + Math.random()}
        className="social-post"
      >
        <>
          {socialPost.videoMp4?.asset?.url ? (
            <video
              className="social-post__video"
              onLoadStart={refreshLayout}
              controls
              poster={imageSrc}
              width={imageWidth}
              height={imageHeight}
            >
              <source
                src={socialPost.videoMp4?.asset?.url}
                type="video/mp4"
              />
              <track kind="captions" />
            </video>
          ) : (
            <a
                href={`${handleUrl}${socialPost.postHandle}`}
              className="social-post__image text-blue-500 hover:underline"
              style={{ fontWeight: 700, color: "black" }}
            >
              <img
                width={imageWidth}
                height={imageHeight}
                onLoad={refreshLayout}
                src={imageSrc}
                loading="lazy"
                alt={socialPost.postHandle}
              />
            </a>
          )}
        </>
        <div className="social-post__copy text-sm leading-tight">
          {socialPost.songLink && socialPost.songTitle && (
            <p className={`social-post__song mb-2`}>
              🎵{" "}
              <a
                style={{ fontWeight: 700 }}
                className="text-blue-500 hover:underline"
                href={socialPost.songLink}
              >
                {socialPost.songTitle}
              </a>
            </p>
          )}

          <div className={`social-post__caption mb-2`}>
            <a
                href={`${handleUrl}${socialPost.postHandle}`}
              className="text-blue-500 hover:underline"
              style={{ fontWeight: 700, color: "black" }}
            >
              {socialPost.postHandle}
            </a>
            <BlockContent
              blocks={socialPost._rawCaption || socialPost.caption}
            />
          </div>
          <p>
            {Array.isArray(socialPost.tags) &&
              socialPost.tags.map((tag) => (
                <>
                  <a
                      href={`${tagUrl}${tag}`}
                    className="social-post__tags text-blue-500 hover:underline"
                    style={{ fontWeight: 700 }}
                  >
                    #{tag}
                  </a>
                  {` `}
                </>
              ))}
            {Array.isArray(socialPost.handles) &&
              socialPost.handles.map((handle) => (
                <>
                  <a
                      href={`${handleUrl}${handle}`}
                    className="social-post__handles text-blue-500 hover:underline"
                    style={{ fontWeight: 700 }}
                  >
                    @{handle}
                  </a>
                  {` `}
                </>
              ))}
          </p>
        </div>
      </div>
    );
}

export default SocialPost;